module.exports = __webpack_public_path__ + "img/sistecredito.c70090ed.svg";